import store from '../store'

export default function showSearch(showSearch, isTag = false) {
	store.dispatch('global_search/SET_SHOW_GLOBAL_SEARCH', [showSearch])
	store.dispatch('global_search/SET_IS_TAG', [isTag])
}
